import { SpinResponse } from '@cgs/data-access';
import { ResponseHolder } from '../../state_machine/response_holder';
import { BaseGameRule } from '../../state_machine/rules/infra/base_game_rule';
import { BaseGameState } from '../../state_machine/states/base_game_state';

export class EndCollapseToBeginCollapse<
  TResponse extends SpinResponse,
> extends BaseGameRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  public ruleCondition(resp: ResponseHolder<TResponse>): boolean {
    const collapseInfo = resp.curResponse.collapseInfo;

    return !!(
      collapseInfo &&
      collapseInfo.groups.length > 0 &&
      collapseInfo.collapsingCounter !== collapseInfo.groups.length &&
      collapseInfo.currentRound?.type === 'collapsingGroup'
    );
  }
}
